import aang from "./assets/Aang.png"
import batman from "./assets/Batman.png"
import finnAndJake from "./assets/Finn-and-Jake.png"
import link from "./assets/Link.png"
import meg from "./assets/Meg.png"
import patrick from "./assets/Patrick-star.png"
import phineasAndFerb from "./assets/Phineas-and-Ferb.png"
import ryuk from "./assets/Ryuk.png"
import theKnight from "./assets/The_Knight_Front.png"
import tom from "./assets/Tom.png"
import turnipHead from "./assets/Turnip-head.png"

export const charactersList = [
    {
        image: aang,
        name: "Aang",
        origin: "Avatar the last airbender",
    },
    {
        image: batman,
        name: "Batman",
        origin: "Batman",
    },
    {
        image: finnAndJake,
        name: "Finn and Jake",
        origin: "Adventure time",
    },
    {
        image: link,
        name: "Link",
        origin: "Zelda",
    },
    {
        image: meg,
        name: "Meg",
        origin: "Family guy",
    },
    {
        image: patrick,
        name: "Patrick",
        origin: "Sponge bob",
    },
    {
        image: phineasAndFerb,
        name: "Phineas and Ferb",
        origin: "Phineas and ferb",
    },
    {
        image: ryuk,
        name: "Ryuk",
        origin: "Death note",
    },
    {
        image: theKnight,
        name: "The knight",
        origin: "Hollow Knight",
    },
    {
        image: tom,
        name: "Tom",
        origin: "Tom and Jerry",
    },
    {
        image: turnipHead,
        name: "Turnip Head",
        origin: "Howl's moving castle",
    },
    
]